/**
 * Public website module — "Planning Appeals". Same postcode/street-name
 * search tool as the agent dashboard (PlanningAppealsTool, in publicMode
 * so it hits the unauthenticated /api/public/planning-appeals/search +
 * case-link endpoints), plus a configurable CTA button linking to any
 * site page.
 */
import PlanningAppealsTool from "@/components/property-admin/PlanningAppealsTool";

function ctaHref(slug) {
  if (slug === null || slug === undefined || slug === "") return null;
  return slug.startsWith("/") ? slug : `/${slug}`;
}

export default function PlanningAppealsModule({ config = {} }) {
  const href = ctaHref(config.cta_page_slug);
  return (
    <div className="max-w-3xl mx-auto px-4 py-10 space-y-6" data-testid="planning-appeals-public-module">
      <div className="text-center space-y-2">
        {config.heading && (
          <h2 className="text-2xl sm:text-3xl font-serif font-medium" data-testid="planning-appeals-module-heading">
            {config.heading}
          </h2>
        )}
        {config.subheading && (
          <p className="text-muted-foreground" data-testid="planning-appeals-module-subheading">
            {config.subheading}
          </p>
        )}
      </div>

      <PlanningAppealsTool publicMode />

      {config.cta_text && href && (
        <div className="text-center pt-2">
          <a
            href={href}
            className="inline-flex items-center justify-center gap-2 font-semibold transition-all duration-200 shadow hover:shadow-lg hover:-translate-y-0.5 whitespace-nowrap px-8 py-4 text-lg"
            style={{
              backgroundColor: "var(--button-bg, var(--primary, #2f4f4f))",
              color: "var(--button-text, #ffffff)",
              borderRadius: "999px",
            }}
            data-testid="planning-appeals-module-cta"
          >
            {config.cta_text}
          </a>
        </div>
      )}
    </div>
  );
}
